import Vue from 'vue';
import Router from 'vue-router';

import ArticleReport from './views/ArticleReport.vue';
import BookingReport from './views/BookingReport.vue';
import UserProfileLite from './views/UserProfileLite.vue';
import AddNewPost from './views/AddNewPost.vue';
import StaffManagement from './views/StaffManagement.vue';
import UserManagement from './views/UserManagement';
import Map from './views/Map.vue';
import PendingApproval from './views/PendingApproval.vue';
import Article from './views/Article.vue';
import Login from './views/Login.vue';
import BookingTimeSlot from './views/BookingTimeSlot';
import Channel from './views/Channel';
import BookingRecord from './views/BookingRecord';
import ChangePassword from './views/ChangePassword';
import ForgotPassword from './views/ForgotPassword';
import NewPassword from './views/NewPassword';
import CreateStaff from './views/CreateStaff.vue';
import CreateUser from './views/CreateUser.vue';
import BookingDetails from './views/BookingDetails';
import SetTimeSlot from './views/SetTimeSlot.vue';
import Errors from './views/Errors.vue';
import Mapmodel from './views/Mapmodel.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/blog-overview',
      name: 'blog-overview',
      component: ArticleReport,
    },
    {
      path: '/booking-report',
      name: 'booking-report',
      component: BookingReport,
    },
    {
      path: '/user-profile-lite',
      name: 'user-profile-lite',
      component: UserProfileLite,
    },
    {
      path: '/add-new-post',
      name: 'add-new-post',
      component: AddNewPost,
    },
    {
      path: '/update-post/:id',
      name: 'update-post',
      component: AddNewPost,
      props: true,
    },
    {
      path: '/staff-management',
      name: 'staff-management',
      component: StaffManagement,
    },
    {
      path: '/user-management',
      name: 'user-management',
      component: UserManagement,
    },
    {
      path: '/map',
      name: 'map',
      component: Map,
    },
    {
      path: '/pending-approval',
      name: 'pending-approval',
      component: PendingApproval,
    },
    {
      path: '/article',
      name: 'article',
      component: Article,
    },
    {
      path: '/booking-time-slot',
      name: 'booking-time-slot',
      component: BookingTimeSlot,
    },
    {
      path: '/channel',
      name: 'channel',
      component: Channel,
    },
    {
      path: '/booking-record',
      name: 'booking-record',
      component: BookingRecord,
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: ChangePassword,
    },
    {
      path: '/new-password',
      name: 'new-password',
      component: NewPassword,
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
    },
    {
      path: '/create-staff',
      name: 'create-staff',
      component: CreateStaff,
    },
    {
      path: '/create-user',
      name: 'create-user',
      component: CreateUser,
    },
    {
      path: '/set-time-slot',
      name: 'set-time-slot',
      component: SetTimeSlot,
    },
    {
      path: '/booking-details/:id',
      name: 'booking-details',
      component: BookingDetails,
      props: true,
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
    },
    {
      path: '*',
      redirect: '/errors',
    },
    {
      path: '/Mapmodel',
      name: 'Mapmodel',
      component: Mapmodel,
    },
  ],
});
